import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { AsmHeaderInterceptor } from './interceptors';

@NgModule({
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useExisting: AsmHeaderInterceptor,
      multi: true,
    },
  ],
})
export class AsmHeaderModule {}
